export default "__VITE_ASSET__BgLCceAY__"